import { render, staticRenderFns } from "./ActiveCashCollectionBranch.vue?vue&type=template&id=4c3a6934&"
import script from "./ActiveCashCollectionBranch.vue?vue&type=script&lang=js&"
export * from "./ActiveCashCollectionBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports